import { TextField, type TextFieldProps, type TextFieldVariants } from '@mui/material';
import {
  Controller,
  type ControllerProps,
  type FieldPath,
  type FieldValues,
} from 'react-hook-form';

interface TextFieldControllerProps<
  // textField generics
  TTextFieldVariant extends TextFieldVariants,
  // controller generics
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> extends Omit<ControllerProps<TFieldValues, TName>, 'render'> {
  label?: TextFieldProps<TTextFieldVariant>['label'];
  slotProps?: {
    textField?: Partial<TextFieldProps<TTextFieldVariant>>;
  };
}

export const TextFieldController = <
  TTextFieldVariant extends TextFieldVariants = TextFieldVariants,
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: TextFieldControllerProps<TTextFieldVariant, TFieldValues, TName>,
) => {
  const { label, slotProps, ...controllerProps } = props;
  return (
    <Controller
      {...controllerProps}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          value={field.value ?? ''}
          label={label}
          error={Boolean(fieldState.error)}
          helperText={fieldState.error?.message}
          {...slotProps?.textField}
        />
      )}
    />
  );
};
